// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RadioButton {
  --border-radius: 4px;
  --inner-border-radius: 4px;
  --color: #ddd;
  --color-checked: #6815ec;
}
.RadioButton__RadioGroup {
  background-color: black !important;
  color: red;
  --border-style: none !important;
}`, "",{"version":3,"sources":["webpack://./libs/features/feat-form-fields/src/lib/radio-button/radio-button.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,0BAAA;EACA,aAAA;EACA,wBAAA;AACF;AACE;EACE,kCAAA;EACA,UAAA;EACA,+BAAA;AACJ","sourcesContent":[".RadioButton {\n  --border-radius: 4px;\n  --inner-border-radius: 4px;\n  --color: #ddd;\n  --color-checked: #6815ec;\n\n  &__RadioGroup {\n    background-color: black !important;\n    color: red;\n    --border-style: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
